import ModalService from "../modal/modal.service";

class CropService {

    constructor($timeout) {
        'ngInject';

        this.$timeout = $timeout;

        this.data = null;
        this.imageData = null;
        this.isModalOpen = false;
        this.dimensions = {
            original: {w: 0, h: 0},
            resized: {w: 0, h: 0}
        }
    }

    openModal() {

    }

    resizeImage(base64image, maxWidth = 1080, maxHeight = 1080, callback) {
        let img = new Image();
        img.src = base64image;
        img.onload = () => {

            // Check if the image require resize at all
            if (img.height <= maxHeight && img.width <= maxWidth) {
                this.dimensions = {
                    original: {w: img.width, h: img.height},
                    resized: {w: img.width, h: img.height}
                }
                callback(base64image);
            } else {
                // Make sure the width and height preserve the original aspect ratio and adjust if needed
                if (img.height > img.width) {
                    maxWidth = Math.floor(maxHeight * (img.width / img.height));
                } else {
                    maxHeight = Math.floor(maxWidth * (img.height / img.width));
                }

                let resizingCanvas = document.createElement('canvas');
                let resizingCanvasContext = resizingCanvas.getContext("2d");

                // Start with original image size
                resizingCanvas.width = img.width;
                resizingCanvas.height = img.height;

                // Draw the original image on the (temp) resizing canvas
                resizingCanvasContext.drawImage(img, 0, 0, resizingCanvas.width, resizingCanvas.height);

                let curImageDimensions = {
                    width: Math.floor(img.width),
                    height: Math.floor(img.height)
                };

                let halfImageDimensions = {
                    width: null,
                    height: null
                };

                // Quickly reduce the dize by 50% each time in few iterations until the size is less then
                // 2x time the target size - the motivation for it, is to reduce the aliasing that would have been
                // created with direct reduction of very big image to small image
                while (curImageDimensions.width * 0.5 > maxWidth) {
                    // Reduce the resizing canvas by half and refresh the image
                    halfImageDimensions.width = Math.floor(curImageDimensions.width * 0.5);
                    halfImageDimensions.height = Math.floor(curImageDimensions.height * 0.5);

                    resizingCanvasContext.drawImage(resizingCanvas, 0, 0, curImageDimensions.width, curImageDimensions.height,
                        0, 0, halfImageDimensions.width, halfImageDimensions.height);

                    curImageDimensions.width = halfImageDimensions.width;
                    curImageDimensions.height = halfImageDimensions.height;
                }

                // Now do final resize for the resizingCanvas to meet the dimension requirments
                // directly to the output canvas, that will output the final image
                let outputCanvas = document.createElement('canvas');
                let outputCanvasContext = outputCanvas.getContext("2d");

                outputCanvas.width = maxWidth;
                outputCanvas.height = maxHeight;

                outputCanvasContext.drawImage(resizingCanvas, 0, 0, curImageDimensions.width, curImageDimensions.height,
                    0, 0, maxWidth, maxHeight);

                // output the canvas pixels as an image. params: format, quality
                this.dimensions = {
                    original: {w: img.width, h: img.height},
                    resized: {w: maxWidth, h: maxHeight}
                }
                callback(outputCanvas.toDataURL('image/jpeg', 0.85));
            }
        };
    }
}

export default CropService;
